import PropTypes from 'prop-types';

import { useSticky } from '../../../hooks/useSticky';
import { DashboardFilters } from './DashboardFilters';
import { DashboardSalesIcon } from '../../icons/analytics';

import { cymbioColors } from '../../../utils/colors';

import stickyStyles from '../../../stylesheets/scss/sticky.module.scss';

export function DashboardHeader(props) {
  const [sticky, ref] = useSticky();

  return (
    <>
      <div className={stickyStyles.headerStickyObserver} ref={ref} />
      <header className={sticky ? stickyStyles.headerSticky : ''}>
        <h1>
          <DashboardSalesIcon color={cymbioColors.analytics.darkBlue} />
          <span>{props.title}</span>
        </h1>

        <DashboardFilters />
      </header>
    </>
  );
}

DashboardHeader.propTypes = {
  title: PropTypes.string.isRequired,
};
